import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { getNewFulfillmentPlanActivity } from './fulfillment-plan-activity.api';
import { EMPTY } from './constants';

const useActivityData = (fpid) => {
  const [activityEntries, setActivityEntries] = useAsyncSafeState();
  const [pageToken, setPageToken] = useAsyncSafeState('');
  const [isLoading, setIsLoading] = useAsyncSafeState(true);

  const loadData = useCallback(() => {
    setIsLoading(true);

    const fetchData = async () => {
      if (pageToken !== EMPTY) {
        const activity = await getNewFulfillmentPlanActivity(fpid, 5, pageToken);
        if (activityEntries?.length) {
          setActivityEntries([...activityEntries, ...(activity?.events || [])]);
        } else {
          setActivityEntries(activity?.events);
        }
        setPageToken(activity?.paginationToken);
      }
      setIsLoading(false);
    };
    return fetchData();
  }, [fpid, activityEntries, pageToken, setIsLoading, setActivityEntries, setPageToken]);

  return {
    activityEntries,
    pageToken,
    loadData,
    isLoading,
  };
};

export default useActivityData;
